module.exports = __webpack_public_path__ + "6d2b62f86980cf93f7da5c422b5f718a.fbx";